"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openTelemetryIntegration = void 0;
const opentelemetry_1 = require("@glovo/opentelemetry");
const constants_1 = require("./constants");
const metrics_definitions_1 = require("./metrics-definitions");
function openTelemetryIntegration({ metricsDefinitions, logger = console, }) {
    opentelemetry_1.metrics.init({
        serviceName: constants_1.SERVICE_NAME,
        exporterOptions: {
            exportIntervalMillis: constants_1.OTEL_METRIC_SCRAPPING_INTERVAL,
        },
    });
    const metrics = metricsDefinitions.reduce((acc, def) => {
        if (!opentelemetry_1.metrics.meter) {
            logger === null || logger === void 0 ? void 0 : logger.warn('CW_OTEL_METRICS', 'Meter not initialized');
            return acc;
        }
        acc[def.name] = (0, metrics_definitions_1.createMetric)(opentelemetry_1.metrics.meter, def);
        return acc;
    }, {});
    return {
        send(metric) {
            const { type, name, tags, value } = metric;
            const definedMetric = metrics[name];
            if (!definedMetric) {
                logger === null || logger === void 0 ? void 0 : logger.warn('CW_OTEL_METRICS', `Metric ${name} not defined`);
                return;
            }
            const handler = metrics_definitions_1.metricHandlers[type];
            if (handler) {
                handler(definedMetric, value, (0, metrics_definitions_1.convertTags)(tags));
            }
            else {
                logger === null || logger === void 0 ? void 0 : logger.warn('CW_OTEL_METRICS', `Handler for metric of type ${type} and name ${name} not found`);
            }
        },
        clear() {
            return __awaiter(this, void 0, void 0, function* () {
                yield opentelemetry_1.metrics.meterProvider.shutdown();
            });
        },
    };
}
exports.openTelemetryIntegration = openTelemetryIntegration;
//# sourceMappingURL=index.js.map